var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.122,
    height: 32.496,
    viewBox: "0 0 43.122 32.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(0.217 -0.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2115",
    "data-name": "Trazado 2115",
    d: "M9.177,9.355H35.06A2.677,2.677,0,0,0,35.06,4H9.177a2.677,2.677,0,0,0,0,5.355Z",
    transform: "translate(5.168 -2.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2116",
    "data-name": "Trazado 2116",
    d: "M35.06,11H9.177a2.677,2.677,0,0,0,0,5.355H35.06a2.677,2.677,0,0,0,0-5.355Z",
    transform: "translate(5.168 3.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2117",
    "data-name": "Trazado 2117",
    d: "M35.06,18H9.177a2.677,2.677,0,0,0,0,5.355H35.06a2.677,2.677,0,0,0,0-5.355Z",
    transform: "translate(5.168 8.653)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_80",
    "data-name": "Elipse 80",
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    transform: "translate(-0.217 0.404)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_81",
    "data-name": "Elipse 81",
    cx: 4.462,
    cy: 4.462,
    rx: 4.462,
    ry: 4.462,
    transform: "translate(0.065 11.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_82",
    "data-name": "Elipse 82",
    cx: 4.462,
    cy: 4.462,
    rx: 4.462,
    ry: 4.462,
    transform: "translate(0.065 23.975)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5f28b3b4c4289c8b4da04b55fea6f846.svg";
export { ForwardRef as ReactComponent };